import { render, staticRenderFns } from "./Calling.vue?vue&type=template&id=0d795db8&"
import script from "./Calling.vue?vue&type=script&lang=js&"
export * from "./Calling.vue?vue&type=script&lang=js&"
import style0 from "./Calling.vue?vue&type=style&index=0&id=0d795db8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports